import { whyJoin } from "../data";

function WhyJoin() {
  return (
    <section className="whySection">
      <p className="sectionTag center">Why Join Orion Academy?</p>

      <div className="whyGrid">
        {whyJoin.map((item, index) => (
          <div className="whyCard" key={index}>✅ {item}</div>
        ))}
      </div>
    </section>
  );
}

export default WhyJoin;
